export default __webpack_public_path__ + "static/media/passLogo.872567f8.svg";